// OpenRouter model persistence hook (browser-local per device).
import { useState } from 'react';

import { DEFAULT_OPENROUTER_CHAT_MODEL, isOpenRouterChatModel } from '@govard/llm-gate-client';
import type { OpenRouterChatModelId } from '@govard/llm-gate-client';

const STORAGE_KEY = 'govard.crm.openrouter-model';
const memoryStorage = new Map<string, string>();

function readStoredModel(): OpenRouterChatModelId {
  if (typeof window === 'undefined') return DEFAULT_OPENROUTER_CHAT_MODEL;
  try {
    const value =
      window.localStorage?.getItem?.(STORAGE_KEY) ?? memoryStorage.get(STORAGE_KEY) ?? null;
    return isOpenRouterChatModel(value) ? value : DEFAULT_OPENROUTER_CHAT_MODEL;
  } catch {
    const value = memoryStorage.get(STORAGE_KEY) ?? null;
    return isOpenRouterChatModel(value) ? value : DEFAULT_OPENROUTER_CHAT_MODEL;
  }
}

export function useOpenRouterModel(): [
  OpenRouterChatModelId,
  (model: OpenRouterChatModelId) => void,
] {
  const [model, setModel] = useState<OpenRouterChatModelId>(readStoredModel);
  return [
    model,
    (nextModel) => {
      setModel(nextModel);
      try {
        window.localStorage?.setItem?.(STORAGE_KEY, nextModel);
      } catch {
        memoryStorage.set(STORAGE_KEY, nextModel);
      }
    },
  ];
}
